import loadable from '@loadable/component';

import { CmsApiPersonaQuizBlockData } from 'modules/cms/api/types/blocks/CmsApiPersonaQuizBlock';
import { CmsBlockMapping } from 'modules/cms/blocks/CmsBlockMapping';
import { CmsMappedBlockWidth } from 'modules/cms/mappers/CmsMappedBlockWidth';

export const CmsPersonaQuizBlockMapping: CmsBlockMapping<CmsApiPersonaQuizBlockData> =
  {
    invariant: [],
    width: CmsMappedBlockWidth.NARROW,
    Component: loadable(() => import('./CmsPersonaQuizBlock'), {
      resolveComponent: (module) => module.CmsPersonaQuizBlock,
    }),
  };
